// extracted by mini-css-extract-plugin
export default {"CreateIndustry":"create-industry_CreateIndustry__qTpQH"};